module.exports = __webpack_public_path__ + "img/l-2.fec5de41.jpg";